import React from 'react';
import PropTypes from 'prop-types';
import ContentList from '../../ui-components/ContentList/ContentList';
import { createListTrackingOnClick } from '../../utils/statistics/clientStatistics';

const SLIDABLELIST_ID = 'slidable-vtp';

const SimilarVideoContent = ({ listContent, headerText }) => {
    if (!listContent) {
        return null;
    }

    const listTracking = {
        listID: 'upptack mer',
        listType: 'balthazar upptack mer',
    };

    const onItemClick = createListTrackingOnClick(listTracking);

    return (
        <ContentList
            id={SLIDABLELIST_ID}
            items={listContent}
            headerText={headerText}
            onItemClick={onItemClick}
            regTestSpec="video-page-similar-content"
            expandable
        />
    );
};

SimilarVideoContent.propTypes = {
    listContent: PropTypes.object,
    titleArticleId: PropTypes.string,
    headerText: PropTypes.string,
    listTracking: PropTypes.object,
};

export default SimilarVideoContent;
